import template from "./choose-plan-modal.html";

const ChoosePlanModalComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
    resolve: "<",
  },
  template: template,
  controller: class ChoosePlanModalController {
    /* @ngInject */
    constructor($rootScope, $state, TrackingStateService) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.TrackingStateService = TrackingStateService;
    }

    $onInit() {
      this.organizations = this.$rootScope.user.organizations;
      this.trialMode = this.resolve.trialMode;
    }

    signout() {
      this.$state.go("signout");
    }
  },
};

export default ChoosePlanModalComponent;
